<template>
  <div>
    <vxe-grid
      ref="table"
      auto-resize
      round
      highlight-hover-row
      :height="tableHeight"
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumn"
      :loading="loading"
      resizable
      border
      :seq-config="{
        startIndex: (tablePage.curPage - 1) * tablePage.pageSize,
      }"
      row-id="recordId"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:table-busy>
        <div class="text-center text-primary my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Loading...</strong>
        </div>
      </template>

      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">{{ $l("INDEX.tips_no_data") || "暂无数据！" }}</p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>


<script>
import TableAutoHeight from "@/mixins/table-auto-height";

export default {
  mixins: [TableAutoHeight],
  props: {
    tablePage: {
      default: null,
      type: Object,
    },
    tableData: {
      default: () => [],
    },
    loading: {
      default: false,
    },
  },
  data() {
    return {
      tableToolbar:{
        slots: {
          buttons: "toolbar_form",
        },
        refresh: {
          query: () => {
            this.$emit("submit");
          },
        },
        zoom: true,
        custom: true,
      },
      tableColumn: [
        {
          field: "seq",
          width: 50,
          fixed: "left",
          align: "center",
          type: "seq",
        },
        {
          field: "departmentName",
          minWidth: 250,
          title: this.$l("table_label_department_name") || "部门名称",
          headerAlign: "center",
          showHeaderOverflow: "title",
          showOverflow: true,
          align: "left",
        },
        {
          field: "userName",
          minWidth: 250,
          title: this.$l("table_label_user_name") || "用户姓名",
          headerAlign: "center",
          showHeaderOverflow: "title",
          showOverflow: true,
          align: "left",
        },
        {
          field: "submitQty",
          width: 200,
          title: this.$l("table_label_releases_number") || "发布数量",
          headerAlign: "center",
          showHeaderOverflow: "title",
          showOverflow: true,
          align: "left",
        },
        {
          field: "categoryName",
          width: 200,
          title:
            this.$l("table_label_supplier_category_name") || "供应商类别名称",
          headerAlign: "center",
          showHeaderOverflow: "title",
          showOverflow: true,
          align: "left",
        },
      ],
    };
  },
  methods: {},
};
</script>
